import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

import DropDown from 'src/components/common/field/DropDown';
import Record from 'src/components/common/table/Record';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import BreadcrumbsCustom from 'src/components/common/BreadcrumbsCustom';
import DialogDetail from 'src/components/quotations/Dialogdetail';
import DialogForm from 'src/components/quotations/DialogForm';
import DialogFormPayment from 'src/components/quotations//Payment/DialogForm';
import ConfirmDelete from 'src/components/common/modal/ConfirmDelete';

import { ItemType } from 'src/components/common/field/TypeCustom';
import { FieldTableType } from 'src/components/common/table/TypeCustom';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import Pagin, { PaginationType } from 'src/components/common/Pagin';
import { useNotify } from 'src/context/ContextNotify';
import { getField } from 'src/common/helper';

const sxlabelDropdown = {
  '&.Mui-focused': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
  '&.MuiInputLabel-root': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
};

const sizeDropdown = {
  width: '160px',
  height: '32px'
};

const defaultFilter = {
  patientid: null,
  patientname: null,
  status: null,
  page: 1,
  pageSize: 10
};

const fieldsDefine: FieldTableType[] = [
  {
    label: '患者ID',
    field: 'patientid',
    align: 'left',
    width: '10%'
  },
  {
    label: '患者名',
    field: 'patientname',
    align: 'left',
    width: '13%'
  },
  {
    label: 'タイトル',
    field: 'title',
    align: 'left',
    width: '13%'
  },
  {
    label: '発行日',
    field: 'quotedate',
    align: 'left',
    width: '12%'
  },
  {
    label: '実施日',
    field: 'date',
    align: 'left',
    width: '12%'
  },
  {
    label: '総額',
    field: 'amount',
    align: 'left',
    width: '12%',
    isPrice: true
  },
  {
    label: 'ステータス',
    field: 'status',
    align: 'left',
    width: '17%',
    isStatus: true,
    boxStatus: true
  },
  {
    label: '',
    field: 'action',
    align: 'center',
    width: '11%'
  }
];

const quotesDefine = [
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 1,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 2,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 3,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 1,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 1,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 1,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 1,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 1,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 1,
    memo: ''
  },
  {
    patientid: '1029',
    patientname: 'たなか　さくらこ\n田中　櫻子',
    id: '7899',
    quotedate: '2024/07/08',
    date: '2024/05/03',
    doctor: '川本 幸司',
    title: '【早割】テスト',
    amount: '328500',
    status: 1,
    memo: ''
  },
];

const statusesDefine = [
  {
    id: '1',
    name: '未支払い',
    accessories: '#FC6E51'
  },
  {
    id: '2',
    name: '支払済み',
    accessories: '#37BC9B'
  },
  {
    id: '3',
    name: '予約済み',
    accessories: '#F6BB42'
  }
];

const paginationDefine = {
  total: 394,
  formatTotal: '394',
  pagesize: 10,
  page: 1,
  pages: 3,
  first: true,
  last: false
}

const breadcrumbsDefine = [
  {
    to: '/',
    label: '会計'
  },
  {
    label: '見積一覧'
  }
];

const dateDialogPaymentDefine = {
  paymentid: 0,
  patientid: 0,
  caseid: 0,
  quoteid: 0,
  open: false
};

const DataDialogDefine = {
  id: 0,
  patientid: 0,
  open: false
};

type DataDialogConfirm = {
  id: number | undefined;
  open: boolean;
};

type DataDialogType = {
  id: number;
  patientid: number;
  open: boolean;
};

type FilterType = {
  patientid: string | null;
  patientname: string | null;
  status: number | null;
  page: number | null;
  pageSize: number | null;
};

const Quotations = () => {
  const notifyContext = useNotify();
  const [filter, setFilter] = useState<FilterType>(defaultFilter);
  const [dataTable, setDataTable] = useState<any[]>(quotesDefine);
  const [statusData, setStatusData] = useState<ItemType[]>([]);
  const [pagination, setPagination] = useState<PaginationType>(paginationDefine);
  const [baseData, setBaseData] = useState<any>({});
  const [loadingDataTable, setLoadingDataTable] = useState(false);

  const [dataDialogDetail, setDataDialogDetail] = useState<DataDialogType>(DataDialogDefine);
  const [dataDialogForm, setDataDialogForm] = useState<DataDialogType>(DataDialogDefine);
  const [dataDialogPayment, setDataDialogPayment] = useState<{
    paymentid: number;
    patientid: number;
    caseid: number;
    quoteid: number;
    open: boolean;
  }>(dateDialogPaymentDefine);

  const [dataDialogConfirm, setdataDialogConfirm] = useState<DataDialogConfirm>({
    id: undefined,
    open: false
  });

  const handleCloseConfirm = () => {
    setdataDialogConfirm({
      id: undefined,
      open: false
    });
  };

  const handleClickDelete = (data: any | undefined) => {
    const id = getField(data, 'id', 0);

    if (id) {
      handleCloseDialogForm();

      setdataDialogConfirm({
        id: Number(id),
        open: true
      });
    }
  };

  const handleCloseDialogForm = (isRefreshList?: boolean) => {
    setDataDialogForm({
      ...DataDialogDefine
    });

    // if (isRefreshList === true) {

    // }
  };

  const handleCloseDialogDetail = (isRefreshList?: boolean) => {
    setDataDialogDetail({
      ...DataDialogDefine
    });
  };

  const handleCloseDialogFormPayment = (isRefreshList?: boolean) => {
    setDataDialogPayment(dateDialogPaymentDefine);
  };

  const handlePageChange = (eventL: any, value: number) => {

  };

  const handleClickRow = (data: any | undefined) => {
    const id = getField(data, 'id', 0);

    if (id) {
      const patientid = getField(data, 'patientid', 0);

      setDataDialogDetail({
        open: true,
        id,
        patientid
      });
    }
  };

  const handleClickPayment = (info: any) => {
    setDataDialogPayment({
      ...info,
      open: true
    });

    if (dataDialogDetail.open) {
      handleCloseDialogDetail();
    }

    if (dataDialogForm.open) {
      handleCloseDialogForm();
    }
  };

  const handleSearch = () => {
    console.log('search');
    // getList();
  };

  const handleClickForm = (data: any | undefined) => {
    setDataDialogForm({
      open: true,
      id: getField(data, 'id', 0),
      patientid: getField(data, 'patientid', 0)
    });
  };

  const handleClickEditFromDetail = (info: any) => {
    setDataDialogForm({
      open: true,
      id: getField(info, 'quoteid', 0),
      patientid: getField(info, 'patientid', 0)
    });

    handleCloseDialogDetail();
  };


  const callAPIDelete = (id: number | undefined) => {
    if (id) {
      const patientId = 123;
      try {
        const token = getToken();

        const data = {
          patientid: patientId,
          id
        };

        postAPI(`/patient/quote-delete?token=${token}`, data)
          .then((res) => {
            handleCloseConfirm();
            if (res.code === 200) {
              notifyContext.setNotifyMessage({
                show: true,
                message: '削除しました。',
                type: 'success',
              });
            };
            if (res.code === 501 || res.code === 500) {
              notifyContext.setNotifyMessage({
                show: true,
                message: res.msg,
                type: 'error'
              });
            }
          })
          .finally(() => {
          });
      } catch (error) {
        console.error('Failed to fetch data:', error);
        return;
      }
    }
  };

  const handleChangeFilter = (name: string) => (id: number | string) => {
    setFilter(prevState => ({
      ...prevState,
      [name]: id !== '' ? id : null
    }))
  };

  useEffect(() => {
    setLoadingDataTable(false);
    setStatusData(statusesDefine);
    setPagination(paginationDefine);
    setBaseData({});
    setDataTable(quotesDefine);
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <BreadcrumbsCustom breadcrumbs={breadcrumbsDefine} />
      <Typography
        component='label'
        sx={{
          fontWeight: '500',
          fontSize: '20px',
          lineHeight: '24px'
        }}
      >
        {'見積一覧'}
      </Typography>
      <Stack
        direction={'row'}
        spacing='8px'
        sx={{
          mt: '18px'
        }}
      >
        <Stack
          direction={'row'}
          spacing='8px'
        >
          {!loadingDataTable ? (
            <DropDown
              selected={Number(filter.patientid)}
              idSelect='patient-id-select'
              defaultSelect={'選択する'}
              placeholder='患者ID'
              onChange={handleChangeFilter('patientid')}
              sxInput={sizeDropdown}
              sxLabel={sxlabelDropdown}
              sxMenuProps={{
                width: sizeDropdown.width
              }}
            />
          ) : (
            <Box width={'160px'}>
              <Skeleton variant='rectangular' width={'160px'} height={'32px'} />
            </Box>
          )}

          {!loadingDataTable ? (
            <DropDown
              selected={filter.patientname}
              idSelect='patient-name-select'
              defaultSelect={'選択する'}
              placeholder='患者名'
              onChange={handleChangeFilter('patientname')}
              sxInput={sizeDropdown}
              sxLabel={sxlabelDropdown}
              sxMenuProps={{
                width: sizeDropdown.width
              }}
            />
          ) : (
            <Box width={'160px'}>
              <Skeleton variant='rectangular' width={'160px'} height={'32px'} />
            </Box>
          )}

          {!loadingDataTable ? (
            <DropDown
              selected={filter.status}
              idSelect='status-select'
              defaultSelect={'選択する'}
              placeholder='ステータス'
              items={statusData}
              onChange={handleChangeFilter('status')}
              sxInput={sizeDropdown}
              sxLabel={sxlabelDropdown}
              sxMenuProps={{
                width: sizeDropdown.width
              }}
            />
          ) : (
            <Box width={'160px'}>
              <Skeleton variant='rectangular' width={'160px'} height={'32px'} />
            </Box>
          )}

          {!loadingDataTable ? (
            <BtnGradient
              text='検索'
              handleButtonClick={handleSearch}
              sx={{
                minWidth: '60px',
                width: '60px',
              }}
            />
          ) : (
            <Box width={'60px'}>
              <Skeleton variant='rectangular' width={'60px'} height={'32px'} />
            </Box>
          )}
        </Stack>

        <Stack
          direction={'row'}
          justifyContent={'right'}
          width={'100%'}
        >
          {!loadingDataTable ? (
            <BtnOutlineGradient
              text='新規作成'
              srcStartIcon='/images/ic-plus-blue.svg'
              handleButtonClick={() => handleClickForm(DataDialogDefine)}
              sx={{
                width: '120px'
              }}
            />
          ) : (
            <Box width={'120px'}>
              <Skeleton variant='rectangular' width={'120px'} height={'32px'} />
            </Box>
          )}
        </Stack>
      </Stack>

      <Box sx={{ mt: '27px' }}>
        {!loadingDataTable ? (
          <Record
            items={dataTable}
            fields={fieldsDefine}
            statuses={statusData}
            baseData={baseData}
            onClickBtnEdit={handleClickForm}
            onClickBtnDelete={handleClickDelete}
            onClickRow={handleClickRow}
          />
        ) : (
          <Skeleton variant='rounded' width={'100%'} height={'400px'} />
        )}
        {!loadingDataTable && dataTable && (
          <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
            <Typography
              component='label'
              sx={{
                color: '#AAB2BD',
                fontWeight: '400',
                fontSize: '10px',
                lineHeight: '12px'
              }}
            >
              {`${paginationDefine.page}-${paginationDefine.pagesize}/${paginationDefine.total}`}
            </Typography>
          </Box>
        )}
      </Box>

      <Box sx={{ width: '100%' }} display={'flex'} justifyContent={'center'}>
        {dataTable.length > 0 && pagination && pagination.page && (
          <Pagin handlePageChange={handlePageChange} pagination={pagination} />
        )}
      </Box>

      <DialogDetail
        open={dataDialogDetail.open}
        patientId={dataDialogDetail.patientid}
        id={dataDialogDetail.id}
        onClose={handleCloseDialogDetail}
        openFormPayment={handleClickPayment}
        openFormQuote={handleClickEditFromDetail}
      />

      <DialogForm
        open={dataDialogForm.open}
        patientId={dataDialogForm.patientid}
        quoteId={dataDialogForm.id}
        onClose={handleCloseDialogForm}
        onDelete={handleClickDelete}
        openFormPayment={handleClickPayment}
      />

      <DialogFormPayment
        open={dataDialogPayment.open}
        infoPayment={dataDialogPayment}
        onClose={handleCloseDialogFormPayment}
      />

      <ConfirmDelete
        openConfirm={dataDialogConfirm.open}
        handleCloseConfirmDelete={handleCloseConfirm}
        handleDelete={() => callAPIDelete(dataDialogConfirm.id)}
      />
    </Box>
  );
}

export default Quotations;